// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import Vuex, { mapState, mapActions } from 'vuex'
import store from './store/store'
import VueCookie from 'vue-cookie'
import Vuelidate from 'vuelidate'

import readableLocalDateTimeOptions from './readableLocalDateTimeOptions'

Vue.use(Vuex)
Vue.use(VueCookie)
Vue.use(VueResource)
Vue.use(Vuelidate)

Vue.config.productionTip = false

// TODO: This is for managing DATO request headers
// Vue.http.interceptors.push(function (request, next) {
//   // REF: https://stackoverflow.com/questions/39665244/vue-resource-interceptor-for-auth-headers
//   // modify headers
//   if (request.url === process.env.DATOS_GRAPHQL_URL) {
//     request.headers.set('Content-Type', 'application/json')
//     request.headers.set('Accept', 'application/json')
//     request.headers.set('Authorization', process.env.DATOS_TOKEN)
//   } else {
//     request.headers.set('Content-Type', 'application/json')
//     request.headers.set('Authorization', 'JWT ' + store.state.userAuthToken)
//   }
//   next()
// })

router.beforeResolve((to, from, next) => {
  if (to.matched.length && to.matched.some(record => record.meta.requiresAuth)) {
    // If route requires admin credentials, i.e., admin route
    if (
      store.state.adminAuthToken !== null &&
      store.state.adminUsername !== null
    ) {
      // Check if store has admin credentials
      window.scrollTo(0, 0)
      next()
    } else if (
      Vue.cookie.get('adminAuthToken') !== null &&
      Vue.cookie.get('adminUsername') !== null
    ) {
      // Otherwise, check if cookies has admin credentials and if localStorage has patient and event data
      // Set into store and continue to admin route
      Promise.all(
        [
          // new Promise(
          //   resolve => {
          //     if (!store.state.patients.isStoreModuleLoaded) { resolve() }
          //
          //     if (
          //       !localStorage.hasOwnProperty('patients') &&
          //       !localStorage.hasOwnProperty('events')
          //     ) {
          //       resolve()
          //     }
          //
          //     if (to.path.includes('/admin')) {
          //       console.log('Loading patients and events from `localStorage`…')
          //       store.commit(
          //         'patients/setAllPatients',
          //         JSON.parse(localStorage.getItem('patients'))
          //       )
          //       store.commit(
          //         'patients/setSortedPatients',
          //         JSON.parse(localStorage.getItem('events'))
          //       )
          //       resolve()
          //     }
          //   }
          // ),
          store.dispatch(
            'saveAdminCredentials',
            {
              adminAuthToken: Vue.cookie.get('adminAuthToken'),
              adminUsername: Vue.cookie.get('adminUsername')
            }
          )
        ]
      ).then(
        () => {
          next()
        }
      )
    } else if (
      store.state.adminAuthToken === null &&
      store.state.adminUsername === null
    ) {
      // If there are no admin credentials in store and cookies
      // Redirect to Admin Login Page
      next({ name: 'Login' })
    } else {
      // TODO: Remove this if it will never be reached
      next({ path: '/register' })
    }
  } else if (to.name && to.matched.length && to.matched.every(record => !record.meta.requiresAuth)) {
    // If route does not require admin credentials, continue on
    next()
  } else {
    // If non-admin route does not exist, redirect to Register Interest Page
    next({ path: '/register' })
  }
})

Vue.http.interceptors.push(function (request) {
  if (
    request.url.includes(process.env.PSP_HOST) &&
    !request.url.includes(process.env.REGISTER_INTEREST_ENDPOINT)
  ) {
    // Common headers
    request.headers.set('Accept', 'application/json')

    if (store.state.adminAuthToken && !store.state.patientAuthToken) {
      request.headers.set('Authorization', `jwt ${store.state.adminAuthToken}`)
    } else if (store.state.patientAuthToken && !store.state.adminAuthToken) {
      request.headers.set('Authorization', `jwt ${store.state.patientAuthToken}`)
    }

    // Method-specific headers
    switch (request.method) {
      case 'POST':
      case 'PUT':
        request.headers.set('Content-Type', 'application/json')
        break
      case 'GET':
      case 'DELETE':
        break
    }
  } else if (request.url === this.brazeEndpoint) {
    request.headers.set('Content-Type', 'application/json')
  }
})

Vue.mixin({
  computed: {
    adminLoginEndpoint () {
      return process.env.PSP_HOST + process.env.AUTH_ENDPOINT
    },
    brazeEndpoint () {
      return process.env.BRAZE_ENDPOINT
    },
    patientsEndpoint () {
      return process.env.PSP_HOST + process.env.PATIENTS_ENDPOINT
    },
    eventsEndpoint () {
      return process.env.PSP_HOST + process.env.EVENTS_ENDPOINT
    },
    rescheduleEventsEndpoint () {
      return process.env.PSP_HOST + process.env.RESCHEDULE_EVENTS_ENDPOINT
    },
    consentEndpoint () {
      return process.env.PSP_HOST + process.env.CONSENT_ENDPOINT
    },
    assessmentEndpoint () {
      return process.env.PSP_HOST + process.env.ASSESSMENT_ENDPOINT
    },
    registerInterestEndpoint () {
      return process.env.PSP_HOST + process.env.REGISTER_INTEREST_ENDPOINT
    },
    sendEmailEndpoint () {
      return process.env.PSP_HOST + process.env.EMAIL_ENDPOINT
    },
    generateJWTForPatientEndpoint () {
      return process.env.PSP_HOST + process.env.GENERATE_JWT_FOR_PATIENT_PATIENT
    },
    timezoneOffsetInMilliseconds () {
      return new Date().getTimezoneOffset() * 60 * 1000
    },
    dateTodayUTCTimestamp () {
      let today = new Date()

      return (
        Date.UTC(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          0,
          0
        ) + this.timezoneOffsetInMilliseconds
      )
    }
  },
  methods: {
    ...mapActions(['resetStore']),
    ...mapActions('patients', ['deleteOneEvent', 'resetPatientsStoreModule']),
    ...mapActions('questionnaire', ['resetQuestionnaireStoreModule']),

    clearAllSessionData: function (params) {
      Promise.all(
        [
          this.resetPatientsStoreModule(),
          this.resetQuestionnaireStoreModule(),
          this.resetStore()
        ]
      ).then(() => {
        this.$cookie.delete('adminUsername')
        this.$cookie.delete('adminAuthToken')
        this.$cookie.delete('patientUsername')
        this.$cookie.delete('patientAuthToken')

        // localStorage.removeItem('patients')
        // localStorage.removeItem('events')

        this.$router.push({ name: 'Login', params: params })
      })
    },
    // Takes in two arguments, If URL param does not exist, return a fallback value if it doesn't exist
    getURLParam: function (param, fallback = null) {
      // Note: Do not use URLSearchParams as that does not work on older iOS browsers
      // REFERENCE: https://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js
      let getUrlParameter = function getUrlParameter (sParam) {
        let sPageURL, sURLVariables, sParameterName, i

        sPageURL = window.location.search.substring(1)
        sURLVariables = sPageURL.split('&')

        for (i = 0; i < sURLVariables.length; i++) {
          let index = sURLVariables[i].indexOf('=') + 1
          sParameterName = []
          sParameterName[0] = sURLVariables[i].substring(0, index - 1)
          sParameterName[1] = decodeURIComponent(sURLVariables[i].substring(index))

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1]
          }
        }
      }
      return getUrlParameter(param) ? getUrlParameter(param) : fallback
    },
    sendEmail (email, subject, body, registerInterest = false) {
      let payload = {
        'email': email,
        'subject': subject,
        'body': body
      }

      return this.makeHttpRequest(
        {
          verb: 'post',
          url: registerInterest ? this.registerInterestEndpoint : this.sendEmailEndpoint,
          body: payload
        }
      )
    },
    deleteEvent (eventGroup, eventId) {
      this.makeHttpRequest(
        {
          verb: 'delete',
          url: this.eventsEndpoint + eventId + '/'
        }
      ).then(
        response => {
          this.deleteOneEvent(
            {
              eventGroup: eventGroup,
              eventId: eventId
            }
          )
        },
        error => {
          Rollbar.error(
            'Error deleting event',
            {
              error: error,
              eventId: eventId
            }
          )
        }
      )
    },
    postConsent (username, consent) {
      return (
        this.makeHttpRequest(
          {
            verb: 'post',
            url: this.consentEndpoint,
            body: {
              username: username,
              action: consent
            }
          }
        )
      )
    },
    // REF: http://2ality.com/2011/11/keyword-parameters.html
    makeHttpRequest ({ verb = null, url = null, body = null, config = null } = {}) {
      return new Promise((resolve, reject) => {
        switch (verb) {
          case 'get':
          case 'delete':
            this.$http[verb](url, config)
              .then(
                response => {
                  resolve(response)
                },
                error => {
                  reject(error)
                }
              )
            break
          case 'post':
          case 'put':
            this.$http[verb](url, body, config)
              .then(
                response => {
                  resolve(response)
                },
                error => {
                  reject(error)
                }
              )
            break
        }
      })
    },
    convertLocalDateOrDateTimeStringToUTCTimestamp (string) {
      if (string === null) { return null }

      // REF: https://stackoverflow.com/a/9436948
      // Check if variable is a string
      if (!(typeof string === 'string' || string instanceof String)) { return null }

      let dateConstituents, timeConstituents

      if (string.includes('T')) {
        let substrings = string.split('T')
        dateConstituents = substrings[0].split('-').map(constituent => Number(constituent))
        timeConstituents = substrings[1].split(':').map(constituent => Number(constituent))
      } else {
        dateConstituents = string.split('-').map(constituent => Number(constituent))
      }

      if (
        !(Array.isArray(dateConstituents) && dateConstituents.length === 3) &&
        !(timeConstituents && Array.isArray(timeConstituents) && timeConstituents.length === 2)
      ) { return null }

      return (
        Date.UTC(
          dateConstituents[0],
          dateConstituents[1] - 1,
          dateConstituents[2],
          timeConstituents ? timeConstituents[0] : 0,
          timeConstituents ? timeConstituents[1] : 0,
          0
        ) + this.timezoneOffsetInMilliseconds
      )
    },
    convertUTCToLocalISODateString (timestamp) {
      return new Date(timestamp - this.timezoneOffsetInMilliseconds).toISOString().split('T')[0]
    },
    convertUTCToLocalISODateTimeString (timestamp) {
      return new Date(timestamp - this.timezoneOffsetInMilliseconds).toISOString().substring(0, 16)
    },
    convertUTCToReadableLocalDateTimeString (timestamp) {
      return (
        new Intl.DateTimeFormat(
          readableLocalDateTimeOptions.locale,
          readableLocalDateTimeOptions.dateTimeString
        ).format(timestamp)
      )
    },
    convertUTCToReadableLocalDateString (timestamp) {
      return (
        new Intl.DateTimeFormat(
          readableLocalDateTimeOptions.locale,
          readableLocalDateTimeOptions.dateString
        ).format(timestamp)
      )
    },
    convertUTCToReadableLocalDateWeekdayString (timestamp) {
      return (
        new Intl.DateTimeFormat(
          readableLocalDateTimeOptions.locale,
          readableLocalDateTimeOptions.dateWeekdayString
        ).format(timestamp)
      )
    },
    convertUTCToReadableLocalTimeString (timestamp) {
      return (
        new Intl.DateTimeFormat(
          readableLocalDateTimeOptions.locale,
          readableLocalDateTimeOptions.timeString
        ).format(timestamp)
      )
    },
    convertWordToTitleCase (word) {
      return (
        `${word[0].toUpperCase() + word.substring(1)}`
      )
    }
    // saveToLocalStorage () {
    //   localStorage.setItem('patients', JSON.stringify(store.state.patients.patients))
    //   localStorage.setItem('events', JSON.stringify(store.state.patients.events))
    // },
    // initializeUniqueIdGenerator: function* (start = 0, end = Infinity, step = 1) {
    //   let startTime = Date.now()
    //   let n = 0
    //   for (let i = start; i < end; i += step) {
    //     n += 1
    //     yield (startTime + i).toString(36)
    //   }
    //   return n
    // }
  }
})

/* eslint-disable no-new */
new Vue(
  {
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    store
  }
)



// WEBPACK FOOTER //
// ./src/main.js